import GetUrls from 'ts/enums/Url'
import { UserType } from 'ts/types'
import useModalStore from 'store/modal'
import { Input } from 'components/ui'
import useModalForm from 'hooks/useModalForm'

const UserTypeAddPage = () => {
  const Url = GetUrls();

  const params = useModalStore((state) => state.params) as UserType
  const { ModalForm, form } = useModalForm()
  const { setValue, register } = form

  if (params) {
    setValue('userTypeId', params.userTypeId)
  }

  return (
    <ModalForm
      config={{ url: Url.postUserType, method: params ? 'PUT' : 'POST' }}
      title={`${params ? 'Edit ' : 'Create ' }User Type`}
      description='Create or edit a User Type'
    >
      <Input
        defaultValue={params?.name}
        label="User Type Name"
        {...register('name', { required: true })}
      />
    </ModalForm>
  )
}

export default UserTypeAddPage
